module.exports = __webpack_public_path__ + "img/woocommerce.4f44535d.jpg";